import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  ScreenDisplayHeaderActions,
  TabButtonFlatButton,
  TextInputField,
} from "../../../common-components";
import {
  AddProductDescriptionInformation,
  AddProductImageAdd,
  AddProductPrimaryInformation,
  InviteCard,
  ProductCard,
} from "./components";

const ProductDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
  refresh,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("block");
  const [search, setSearch] = useState("");
  const [activeView, setActiveView] = useState("catalog");
  const [filterTest, setFilterTest] = useState(false);
  const [filterTest1, setFilterTest1] = useState(false);
  const [addProductStep, setAddProductStep] = useState(1);
  const [tableDisplay, setTableDisplay] = useState("all");

  const [selectedUser, setSelectedUser] = useState(null);

  const [inviteEmail, setInviteEmail] = useState("");
  const [invitePin, setInvitePin] = useState("");

  const [linkedInvites, setLinkedInvites] = useState("");
  const [linkedUsers, setLinkedUsers] = useState("");
  const [originalLinkedInvites, setOriginalLinkedInvites] = useState([]);

  const [selectedRole, setSelectedRole] = useState("");

  const [users, setUsers] = useState(null);
  const [originalUsers, setOriginalUsers] = useState([]);

  // https://driverfrienddatabase-h2aa.onrender.com/userInvites/getAllUsers
  const GetAllUsers = async () => {
    await fetch(process.env.REACT_APP_BACKEND_URL + "/userInvites/getAllUsers")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setUsers(resData.users);
        setOriginalUsers(resData.users);
      });
  };

  const SendInvite = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/createInviteAndSend",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: inviteEmail,
            roles: [selectedRole],
            linkedId: auth.customerUserData.userId,
            linkedBrand: "DRIVERS FRIEND CORE",
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            pin: invitePin,
            type: "admin",
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.message) {
        setLoading(false);
        setToastPop(true);
        setMessage("You have succesfully sent the invite");
        setPopUpTitle("SUCCESS");
        setActiveView("catalog");

        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      } else {
        setLoading(false);
        // setInvitesArray(respnseData.invites);
      }
    } catch (err) {
      setLoading(false);

      console.log("error", err);
    }
  };

  const GetLinkedInvites = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getAllInvites",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            linkedId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.invites) {
        setLoading(false);
        setLinkedInvites(respnseData.invites);
        setOriginalLinkedInvites(respnseData.invites);
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      } else {
        setLoading(false);
        setLinkedInvites(respnseData.invites);
        setOriginalLinkedInvites(respnseData.invites);
        // setInvitesArray(respnseData.invites);
      }
    } catch (err) {
      setLoading(false);

      console.log("error", err);
    }
  };

  const SubmitHandler = () => {
    setToastPop(true);
    setMessage("You have succesfully upload a new product");
    setPopUpTitle("SUCCESS");
    setActiveView("catalog");
    setAddProductStep(1);
  };
  useEffect(() => {
    setOpen(true);
    GetAllUsers();
    GetLinkedInvites();
  }, [tableDisplay]);
  useEffect(() => {
    GetAllUsers();
    GetLinkedInvites();
  }, [refresh]);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
      }}
    >
      <div
        style={{
          display: "flex",
          height: 40,
          backgroundColor: colors.greenDark,
          top: -40,
          position: "absolute",
        }}
      >
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"ALL USERS"}
            backgroundColor={
              tableDisplay === "all" ? colors.secondaryGrey : colors.greenLight
            }
            textColor={tableDisplay === "all" ? colors.greenDark : colors.white}
            onClick={() => setTableDisplay("all")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"INVITES"}
            backgroundColor={
              tableDisplay === "invites"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "invites" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("invites")}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"AGENCY & ADMIN"}
            backgroundColor={
              tableDisplay === "admin&agency"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "admin&agency" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("admin&agency")}
          />
        </div>
      </div>
      {/* catalog view */}
      <div
        style={{
          height: activeView === "catalog" ? "100%" : 0,
          width: "100%",
          //   borderStyle: "solid",
          //borderRadius: 15,
          //   borderColor: colors.primaryBlue,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "height 0.3s",
        }}
      >
        {tableDisplay === "all" || tableDisplay === "admin&agency" ? (
          <ScreenDisplayHeaderActions
            user={true}
            title={"USER LIST"}
            iconRight1={require("../../../../images/icons/blockWhite.png")}
            iconRight1Height={30}
            iconRight1Width={30}
            iconRight2={require("../../../../images/icons/listWhite.png")}
            iconRight1Change={require("../../../../images/icons/blockDarkBlue.png")}
            iconRight2Change={require("../../../../images/icons/listDarkBlue.png")}
            iconRight2Height={30}
            iconRight2Width={30}
            //   marginBottom={10}
            selected={selectedView}
            onListClick={() => setSelectedView("list")}
            onBlockClick={() => setSelectedView("block")}
            search={search}
            onSearchChange={(e) => setSearch(e.target.value)}
            onAddProductClick={() => setActiveView("add")}
            marginBottom={20}
            originalDataArray={originalUsers}
            searchArray={users}
            setSearchArray={setUsers}
          />
        ) : null}
        {tableDisplay === "invites" ? (
          <ScreenDisplayHeaderActions
            user={true}
            title={"INVITES LIST"}
            iconRight1={require("../../../../images/icons/blockWhite.png")}
            iconRight1Height={30}
            iconRight1Width={30}
            iconRight2={require("../../../../images/icons/listWhite.png")}
            iconRight1Change={require("../../../../images/icons/blockDarkBlue.png")}
            iconRight2Change={require("../../../../images/icons/listDarkBlue.png")}
            iconRight2Height={30}
            iconRight2Width={30}
            //   marginBottom={10}
            selected={selectedView}
            onListClick={() => setSelectedView("list")}
            onBlockClick={() => setSelectedView("block")}
            search={search}
            onSearchChange={(e) => setSearch(e.target.value)}
            onAddProductClick={() => setActiveView("add")}
            marginBottom={20}
            originalDataArray={originalLinkedInvites}
            searchArray={linkedInvites}
            setSearchArray={setLinkedInvites}
          />
        ) : null}
        {tableDisplay === "all" ? (
          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* filter panel */}
            {/* <div
            style={{
              height: "99%",
              width: 200,
              //   borderStyle: "solid",
              //   borderWidth: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div style={{ width: "100%", textAlign: "left" }}>
              <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
                Filters
              </div>
            </div>
            <div
              style={{
                height: 30,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                textAlign: "left",
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  height: 3,
                  width: "92%",
                  backgroundColor: colors.secondaryDarkBlue,
                  position: "absolute",
                  bottom: 0,
                  opacity: 0.75,
                  borderRadius: 8,
                }}
              />
              <div
                style={{
                  marginLeft: 10,
                  width: "100%",
                  fontSize: 14,
                  fontWeight: "bold",
                  opacity: 0.8,
                }}
              >
                {" "}
                Section title
              </div>
            </div>
            <CheckInput
              label={"Label"}
              onClick={() => setFilterTest(filterTest ? false : true)}
              selected={filterTest}
            />
            <CheckInput
              label={"Label"}
              selected={filterTest1}
              onClick={() => setFilterTest1(filterTest1 ? false : true)}
            />
            <CheckInput label={"Label"} />
            <CheckInput label={"Label"} />
          </div> */}
            {/* hedears */}
            <div
              style={{
                width: "100%",
                backgroundColor: colors.greenDark,
                height: 40,
                display: "flex",
              }}
            >
              <div
                style={{
                  flex: 0.05,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></div>
              <div
                style={{
                  flex: 0.2,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div style={{ marginLeft: 10 }}> FIRST NAME</div>
                </div>
              </div>
              <div
                style={{
                  flex: 0.2,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}> LASTNAME</div>
              </div>
              <div
                style={{
                  flex: 0.25,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}> EMAIL</div>
              </div>
              <div
                style={{
                  flex: 0.2,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%" }}> CELL NUMBER</div>
              </div>

              <div
                style={{
                  flex: 0.1,
                  color: colors.white,
                  fontWeight: "bold",
                  fontSize: 12,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "left",
                }}
              >
                ACTIONS
              </div>
            </div>

            <div
              style={{
                maxHeight: height > 800 ? 730 : height > 740 ? 600 : 550,
                minHeight: 300,
                height: "90%",
                flex: 1,
                borderWidth: 1,
                flexDirection: "column",
                // flexWrap: "wrap",
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              {users
                ? users.map((user, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          minHeight: 50,
                          maxHeight: 50,
                          width: width > 1200 ? "100%" : "100%",

                          // borderRadius: 10,
                          margin: 1,
                          position: "relative",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          // overflow: "hidden",
                        }}
                      >
                        <ProductCard
                          onManageClick={() => {
                            setActiveView("manage");
                            setSelectedUser(user);
                          }}
                          firstName={user.firstName}
                          lastName={user.lastName}
                          email={user.email}
                          cellNumber={user.cellNumber}
                        />
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        ) : null}
        {tableDisplay === "invites" ? (
          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            {linkedInvites
              ? linkedInvites.map((invites, index) => {
                  return (
                    <div key={index} style={{ width: "100%", marginTop: 20 }}>
                      <InviteCard
                        username={invites.email}
                        roles={invites.roles[0]}
                        status={invites.status}
                        createdOn={invites.createdOn}
                      />
                    </div>
                  );
                })
              : null}
          </div>
        ) : null}
      </div>
      {/* invite user view */}
      <div
        style={{
          height: activeView === "add" ? "100%" : 0,
          width: "100%",
          //   borderStyle: "solid",
          borderRadius: 15,
          //   borderColor: colors.primaryBlue,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "height 0.3s",
          position: "absolute",
          bottom: 0,
        }}
      >
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <TextInputField
                labelTitle={"EMAIL"}
                mini={true}
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
              <TextInputField
                labelTitle={"PIN"}
                mini={true}
                value={invitePin}
                onChange={(e) => setInvitePin(e.target.value)}
              />

              <div
                style={{
                  marginTop: 20,
                  marginBottom: 15,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SELECT ROLES
              </div>
              <div style={{ width: 250, fontSize: 12, marginBottom: 10 }}>
                Depending on the role assigend to user will display different
                Admin screens and modules
              </div>
              <CheckInput
                label={"ADMIN"}
                selected={selectedRole === "ADMIN"}
                onClick={() => setSelectedRole("ADMIN")}
              />
              <CheckInput
                label={"SUPPORT"}
                selected={selectedRole === "SUPPORT"}
                onClick={() => setSelectedRole("SUPPORT")}
              />
              <CheckInput
                label={"AGENCY"}
                selected={selectedRole === "AGENCY"}
                onClick={() => setSelectedRole("AGENCY")}
              />
            </div>
          </div>
          {/* back and close buttons */}
          <div style={{ position: "absolute", top: 10, left: 10 }}>
            {addProductStep === 1 ? (
              <BaseButtons
                label={"CLOSE"}
                width={100}
                backgroundColor={colors.secondaryOrange}
                onClick={() => setActiveView("catalog")}
                borderRadius={10}
              />
            ) : null}
            {addProductStep === 2 ? (
              <BaseButtons
                label={"BACK"}
                width={100}
                backgroundColor={colors.secondaryOrange}
                onClick={() => setAddProductStep(1)}
                borderRadius={10}
              />
            ) : null}
            {addProductStep === 3 ? (
              <BaseButtons
                label={"BACK"}
                width={100}
                backgroundColor={colors.secondaryOrange}
                onClick={() => setAddProductStep(2)}
                borderRadius={10}
              />
            ) : null}
            {addProductStep === 4 ? (
              <BaseButtons
                label={"BACK"}
                width={100}
                backgroundColor={colors.secondaryOrange}
                onClick={() => setAddProductStep(3)}
                borderRadius={10}
              />
            ) : null}
          </div>
          {/* next and complete buttons */}
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <BaseButtons
              label={"SEND INVITE"}
              width={150}
              backgroundColor={colors.greenLight}
              borderRadius={10}
              onClick={() => SendInvite()}
            />

            {addProductStep === 2 ? (
              <BaseButtons
                label={"NEXT"}
                width={100}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={10}
                onClick={() => setAddProductStep(3)}
              />
            ) : null}
            {addProductStep === 3 ? (
              <BaseButtons
                label={"NEXT"}
                width={100}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={10}
                onClick={() => setAddProductStep(4)}
              />
            ) : null}
            {addProductStep === 4 ? (
              <BaseButtons
                label={"SUBMIT"}
                width={100}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={10}
                // onClick={() => SubmitHandler()}
              />
            ) : null}
          </div>
          <div
            style={{
              position: "absolute",
              top: 15,
              fontSize: 26,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              left: 140,
            }}
          >
            INVITE USER
          </div>
        </div>
      </div>
      {/* manage product view */}
      <div
        style={{
          height: "100%",
          width: activeView === "manage" ? "100%" : 0,
          //   borderStyle: "solid",
          borderRadius: 15,
          //   borderColor: colors.primaryBlue,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "all 0.3s",
          position: "absolute",
          right: 0,
          backgroundColor: colors.secondaryGrey,
          opacity: activeView === "manage" ? 1 : 0,
        }}
      >
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              height: "100%",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              flexDirection: "row",
            }}
          >
            <div style={{ minWidth: 200, flex: 0.5 }}>
              <div style={{ marginTop: 80, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  First Name:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.firstName : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Last Name:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.lastName : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Address:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.address : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Id NUmber:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.idDoc : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  title:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.title : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Date of birth:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.dateOfBirth : "loading"}
                </div>
              </div>
            </div>
            <div style={{ minWidth: 200, flex: 0.5 }}>
              <div style={{ marginTop: 80, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Email:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.email : "loading"}
                </div>
              </div>

              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Cell number:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.cellNumber : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Land line Number:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.landline : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Account type:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser ? selectedUser.type : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10, marginLeft: 20 }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 12, marginBottom: 5 }}
                >
                  Contact me on whatsapp:
                </div>
                <div style={{ fontSize: 16 }}>
                  {selectedUser
                    ? selectedUser.whatsAppContact === "true"
                      ? "YES"
                      : "NO"
                    : "loading"}
                </div>
              </div>
            </div>
          </div>
          {/* back and close buttons */}
          <div style={{ position: "absolute", top: 10, left: 10 }}>
            <BaseButtons
              label={"CLOSE"}
              width={100}
              backgroundColor={colors.secondaryOrange}
              onClick={() => setActiveView("catalog")}
              borderRadius={10}
            />
          </div>
          {/* next and complete buttons */}
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <BaseButtons
              label={"SAVE CHANGES"}
              width={100}
              backgroundColor={colors.secondaryDarkBlue}
              borderRadius={10}
              // onClick={() => SubmitHandler()}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: 15,
              fontSize: 26,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              left: 140,
            }}
          >
            MANAGE USER DATA & ROLES
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDisplay;
